module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-6-big-14c1563b749d1f1c2e3ad87b97c1205d.jpg";